import React from "react";
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";
import { Link } from "react-router-dom";
import imgSupport from "../../assets/img/home.png"; // Cambia a la imagen correcta

const SpecializedSupport = () => {
  const { ref, inView } = useInView({
    triggerOnce: true, // Solo se activa una vez al bajar
    threshold: 0.2, // Se activa cuando el 20% del componente es visible
  });

  return (
    <section ref={ref} className="max-w-7xl mx-auto px-6 py-16">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
        {/* Contenido de Texto */}
        <motion.div
          initial={{ opacity: 0, x: -50 }}
          animate={inView ? { opacity: 1, x: 0 } : {}}
          transition={{ duration: 0.8, ease: "easeOut" }}
        >
          <h2 className="text-4xl font-bold text-gray-900">
            Specialized Virtual Support <br /> For Your Law Firm
          </h2>

          <p className="mt-4 text-lg text-gray-600 leading-relaxed">
            At your virtual office, we’re not just staffing providers—we’re growth partners.
            Our goal is to help your firm thrive, enabling you to focus on winning
            cases while we handle the rest.
          </p>

          <p className="mt-4 text-lg text-gray-600 leading-relaxed">
            Whether you need to fill multiple full-time paralegal roles, find the
            perfect assistant to handle intake and marketing, or just need some help
            with the phones after-hours, your virtual office has your back.
          </p>

          <Link
            to="/get-started"
            className="mt-6 inline-block px-6 py-3 bg-red-400 text-white text-lg font-medium rounded-full shadow-md hover:bg-red-500 transition-all"
          >
            Get Started
          </Link>
        </motion.div>

        {/* Imagen con Fondo Redondeado */}
        <motion.div
          initial={{ opacity: 0, x: 50 }}
          animate={inView ? { opacity: 1, x: 0 } : {}}
          transition={{ duration: 0.8, ease: "easeOut", delay: 0.2 }}
          className="flex justify-center"
        >
          <div className="relative">
            <div className="absolute -top-4 -left-4 w-full h-full bg-red-200 rounded-full -z-10"></div>
            <img src={imgSupport} alt="Virtual Support" />
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default SpecializedSupport;
